import { render } from "./CaptioningManage.vue?vue&type=template&id=67efc40a"
import script from "./CaptioningManage.vue?vue&type=script&setup=true&lang=js"
export * from "./CaptioningManage.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Captioning/CaptioningManage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67efc40a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67efc40a', __exports__)) {
    api.reload('67efc40a', __exports__)
  }
  
  module.hot.accept("./CaptioningManage.vue?vue&type=template&id=67efc40a", () => {
    api.rerender('67efc40a', render)
  })

}


export default __exports__